import React from 'react';

import { CalendarDisplay } from './components/CalendarDisplay';
import { PeopleDisplay } from './components/PeopleDisplay';

import Loading from './components/Loading';
import CalendarSelectView from './views/CalendarSelectView';

import { LocalString, Plural, Money } from 'translate-react';

import { connect } from 'react-redux';

import makeReducer from './src/makeReducer';

import {
	togglePanel, TOGGLE_PANEL,
	addRoom, ADD_ROOM,
	resetDate, RESET_DATE,
	CLICK_DAY,
	executeSearch,
 } from './actions.js';

let Box = require('./desktop/Box.js').default;
let TimeColumns = require('./desktop/TimeColumns.js').default;
let ObjectColumns = require('./desktop/ObjectColumns.js').default;
let ExtrasColumns = require('./desktop/ExtrasColumns.js').default;
let BookingColumns = require('./desktop/BookingColumns.js').default;
let ObjectContent = require('./desktop/ObjectContent.js').default;
let Footer = require('./components/Footer.js').default;

let ResultsList  = require('./desktop/ResultsList.js').default;

if ( module.hot ) {
	module.hot.accept('./desktop/ResultsList.js', () => {
		ResultsList = require('./desktop/ResultsList.js').default;
	});
	module.hot.accept('./desktop/Box.js', () => {
		Box = require('./desktop/Box.js').default;
	});
	module.hot.accept('./desktop/TimeColumns.js', () => {
		TimeColumns = require('./desktop/TimeColumns.js').default;
	});
	module.hot.accept('./desktop/ObjectColumns.js', () => {
		ObjectColumns = require('./desktop/ObjectColumns.js').default;
	});
	module.hot.accept('./desktop/ExtrasColumns.js', () => {
		ExtrasColumns = require('./desktop/ExtrasColumns.js').default;
	});
	module.hot.accept('./desktop/BookingColumns.js', () => {
		BookingColumns = require('./desktop/BookingColumns.js').default;
	});
	module.hot.accept('./components/Footer.js', () => {
		Footer = require('./components/Footer.js').default;
	});
	module.hot.accept('./desktop/ObjectContent.js', () => {
		ObjectContent = require('./desktop/ObjectContent.js').default;
	});
}


var defaultPanelState = {
	date: true,
	initial_offers: true,
	room1: false,
	room2: false,
	room3: false,
	extras: false,
	booking: false,
}

var defaultPanelVisibility = {
	date: true,
	initial_offers: true,
	room1: false,
	room2: false,
	room3: false,
	extras: false,
	booking: false,	
}

var defaultRoomState = {
	people_open: true,
	results: [],
}

var defaultState = {
	rooms: 1,
	panelState: defaultPanelState,
	panelVisibility: defaultPanelVisibility,
	dateSelecting: false,
	initialOffers: [],
	room1: { ...defaultRoomState },
	room2: { ...defaultRoomState },
	room3: { ...defaultRoomState },
}



export var desktopReducer = makeReducer({

	default: _ => defaultState,

	[TOGGLE_PANEL]: (state, action) => {
		// Hide all panels
		let panelState = { date: false, room1: false, extras: false, booking: false };
		//panelState = { ...state.panelState };
		// Active the requested panel, except it was already open before
		panelState[action.panel] = !state.panelState[action.panel];
		return { ...state, panelState };
	},

	[ADD_ROOM]: (state, action) => {
		state = {
			...state,
			rooms: Math.min(state.rooms + 1, 3),
			panelState: { ...state.panelState },
			panelVisibility: { ...state.panelVisibility },
		};
		state.panelState["room" + (state.rooms - 1)] = false;
		state.panelState["room" + state.rooms] = true;
		state.panelVisibility["room" + state.rooms] = true;
		state.panelVisibility["extras"] = true;
		state.panelVisibility["booking"] = true;
		return state;
	},

    [CLICK_DAY]: (state, action) => {
        if ( state.dateSelecting ) {
            return {
                ...state,
                dateSelecting: false,
                panelState: { ...defaultState, date: false, room1: true, },
                panelVisibility: { ...state.panelVisibility, initial_offers: false, room1: true, }
            };
        } else {
            return {
                ...state,
                rooms: 1,
                dateSelecting: true,
                panelState: defaultPanelState,
                panelVisibility: defaultPanelVisibility,
            };
        }
   },

    ['RECEIVED_INITIAL_OFFERS']: (state, action) => {
        return {
            ...state,
            initialOffers: action.results,
        }
   },

    [RESET_DATE]: (state, action) => {
        return {
            ...state,
            rooms: 1,
            dateSelecting: false,
            panelState: defaultPanelState,
            panelVisibility: defaultPanelVisibility,
        }
   },

});


const DesktopApp = function(props) {
	let { selecting, desktop } = props;
	let { executeSearch, togglePanel } = props;

	let { panelState, rooms, initialOffers } = desktop;

	let calendarClick = function(date) {
		if ( selecting ) {
            executeSearch();
        }
	};

	return (
		<div className="desktop">

			<Box title="Zeitraum" columns={TimeColumns} open={panelState['date']} ident="date">
				<CalendarSelectView count={2} onClick={calendarClick} />
				<div className="search-info">
					<button className="search-btn" onClick={() => togglePanel("date")}>
						<LocalString word="search_btn" />
					</button>
					<p><LocalString word="calendar_hint" /></p>
				</div>
			</Box>

			<Box title="Angebote" open={true} ident="initial_offers">
				{ initialOffers.length > 0
					? <ResultsList results={initialOffers} />
					: <Loading text="Einen Moment, ich habe da was für Sie..." />
				}
			</Box>

			<Box title="Hotelzimmer" columns={ObjectColumns} open={panelState['room1']} ident="room1">
				<ObjectContent room={1} />
			</Box>

			{rooms > 1 ? 
			<Box title="Ferienwohnung" columns={ObjectColumns} open={panelState['room2']} ident="room2">
				<ObjectContent room={2} />
			</Box>
			: null}

			{rooms > 2 ? 
			<Box title="Altglascontainer" columns={ObjectColumns} open={panelState['room3']} ident="room3">
				<ObjectContent room={3} />
			</Box>
			: null}

			<Box title="Extras" columns={ExtrasColumns} open={panelState['extras']} ident="extras">
				
			</Box>

			<Box title="Buchung" columns={BookingColumns} open={panelState['booking']} ident="booking">
				
			</Box>

			<Footer />
			
		</div>
	);
};



const mapStateToProps = (state) => ({
    selecting: state.calendar.selecting,
    desktop: state.desktop,
    locale: state.locale,
})

const mapDispatchToProps = (dispatch) => ({
	executeSearch: _ => dispatch(executeSearch()),
	togglePanel: panel => dispatch(togglePanel(panel)),
})

export default connect(mapStateToProps, mapDispatchToProps)(DesktopApp);





/** WEBPACK FOOTER **
 ** ../ibe/DesktopApp.js
 **/